// IE 2026 11 02 / ODOO-350612 (fe.i18n.loginHoldTarget): адрес перезагрузки после входа паролем, когда язык USER (get_user) требует
// перезагрузки страницы (store.i18n_firstLoadHold). Без цели перезагрузка шла на тот же #/<db>/login — router.beforeEach на маршруте
// входа сессию не восстанавливает и снова показывал форму (разбор webscm, карточка 350612: uk-UA браузер при пользователе en —
// две загрузки, форма; en-US — стол за 1,35 с). Цель — маршрут базы с теми же process_model / workspace / page, что берёт штатный
// переход после входа (mainStore.login → $router.push); ?next= и прочие параметры формы не переносятся.
// route — vueObj.$route ({ name, params, query }); dbid — база из адреса или ответа; answer — ответ login (show_database_selector →
// цель не задаём: прежний путь, выбор базы). null — цели нет, перезагрузка текущего адреса (как раньше).
export const LOGIN_TARGET_QUERY_KEYS = ['process_model', 'workspace', 'page']

export function loginHoldTarget(route, dbid, answer = null) {
    try {
        const name = route?.name
        if (name !== 'dbLogin' && name !== 'login') return null
        if (answer?.show_database_selector) return null
        const db = dbid || route?.params?.dbid || ''
        if (!db || typeof db !== 'string') return null
        const q = new URLSearchParams()
        for (const k of LOGIN_TARGET_QUERY_KEYS) {
            const v = route?.query?.[k]
            if (v && typeof v === 'string') q.set(k, v)
        }
        const qs = q.toString()
        return { fullPath: `/${db}` + (qs ? `?${qs}` : '') }
    } catch (e) { return null }
}
